import { Config } from './index';

const config: Config = {
  calculationApiUrl: 'https://qa-api.b2tech.com/api/v1/calculate',
  debug: true,
  version: '0.0.1',
  environment: 'qa'
};

export default config;